// extracted by mini-css-extract-plugin
export default {"container":"Quote_container__Ma-P5","line":"Quote_line__VHoQF"};